module.exports = __webpack_public_path__ + "19bfa0c7574c321a5a1c3035d2c8c494.pdf";